
import { defineComponent } from 'vue';

import TPCommonHeader from '@/components/common/TPCommonHeader.vue';
import TPInquiryModal from '@/components/TPInquiryModal.vue';

export default defineComponent({
  components: {
    TPCommonHeader,
		TPInquiryModal
	},
  data() {
		return {
			showInquiryModal: false,
			scrolled: false
		};
  },
  methods: {
    toggleInquiryModal() {
      this.showInquiryModal = !this.showInquiryModal;
		},
		handleScroll() {
			console.log('스크롤링')

			const scrollY = window.scrollY;
			if (scrollY > 100) {
				this.scrolled = true
			} else {
				this.scrolled = false
			}
		}
	},

});
